module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": this._uid
    }
  }, [_c('div', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86e01d44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/map/GoogleMapMarkerCluster.vue
// module id = 2627
// module chunks = 1